import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext.jsx';
import { FaShieldAlt, FaExclamationTriangle } from 'react-icons/fa';

const AdminProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();

  // Afficher un loader pendant la vérification de l'authentification
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Vérification des permissions d'administration...</p>
        </div>
      </div>
    );
  }

  // Rediriger vers login si non authentifié
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  // Debug: Afficher les informations de l'utilisateur
  console.log('🔍 AdminProtectedRoute - User:', user);
  console.log('🔍 AdminProtectedRoute - User role:', user?.role);
  console.log('🔍 AdminProtectedRoute - User roleId:', user?.roleId);
  console.log('🔍 AdminProtectedRoute - User role.nom:', user?.role?.nom);

  // Vérifier si l'utilisateur a le rôle d'administrateur AdminPanel
  const isAdmin = user?.role?.nom === 'AdminPanel' || 
                  user?.role === 'AdminPanel' || 
                  user?.roleId === 1 || // ID du rôle AdminPanel
                  user?.email === 'admin@securetech.com' || // Admin principal
                  user?.role?.nom === 'AdminRH' || // Temporaire pour tester
                  user?.role === 'AdminRH'; // Temporaire pour tester

  console.log('🔍 AdminProtectedRoute - Is Admin:', isAdmin);

  if (!isAdmin) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="text-center bg-white p-8 rounded-lg shadow-lg max-w-md">
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <FaExclamationTriangle className="w-10 h-10 text-red-500" />
          </div>
          <h2 className="text-2xl font-bold text-gray-800 mb-4">Accès Refusé</h2>
          <p className="text-gray-600 mb-6">
            Vous n'avez pas les permissions nécessaires pour accéder au panneau d'administration SecureTech.
            Seuls les administrateurs peuvent accéder à cette interface.
          </p>
          <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
            <p className="text-sm text-red-700">
              <strong>Votre rôle actuel:</strong> {user?.role?.nom || user?.role || 'Non défini'}
            </p>
            <p className="text-sm text-red-700 mt-1">
              <strong>Rôle requis:</strong> AdminPanel
            </p>
          </div>
          <div className="flex space-x-4">
            <button
              onClick={() => window.location.href = '/dashboard'}
              className="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-lg transition-colors duration-200"
            >
              Aller au Dashboard
            </button>
            <button
              onClick={() => window.location.href = '/login'}
              className="flex-1 bg-gray-600 hover:bg-gray-700 text-white font-medium py-2 px-4 rounded-lg transition-colors duration-200"
            >
              Se reconnecter
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Afficher le contenu admin si l'utilisateur est authentifié et a les bonnes permissions
  return children;
};

export default AdminProtectedRoute;
